import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDbIcAddCircle24 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "icon",
	height: 24,
	viewBox: "0 0 24 24",
	width: 24,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m12 2c5.516 0 10 4.484 10 10s-4.484 10-10 10-10-4.484-10-10 4.484-10 10-10zm0 2.019a7.975 7.975 0 0 0 -7.981 7.981 7.975 7.975 0 0 0 7.981 7.981 7.975 7.975 0 0 0 7.981-7.981 7.975 7.975 0 0 0 -7.981-7.981zm0 2.981c.563 0 1 .437 1 1v3h3c.563 0 1 .437 1 1s-.437 1-1 1l-2.99.01-.01 2.99c0 .563-.437 1-1 1s-1-.437-1-1v-3l-2.99.01c-.565 0-1.01-.448-1.01-1.01s.437-1 1-1h3v-3c0-.563.437-1 1-1z",
		fill: "var(--db-icon-color, currentColor)",
		fillRule: "evenodd"
	})
});
export default SvgDbIcAddCircle24;
